import { render, staticRenderFns } from "./ProjectAssignedMilestones.vue?vue&type=template&id=24c98eee&scoped=true&"
import script from "./ProjectAssignedMilestones.vue?vue&type=script&lang=js&"
export * from "./ProjectAssignedMilestones.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAssignedMilestones.vue?vue&type=style&index=0&id=24c98eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c98eee",
  null
  
)

export default component.exports